export default function (state) {
    return !!state.user.auth;
}